/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableToJSON,
} from './JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable';
import {
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSON,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSONTyped,
    JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationToJSON,
} from './JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest
 */
export interface JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest {
    /**
     * クーポン適用対象者
     * @type {Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable>}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest
     */
    couponApplicable?: Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicable>;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation>}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest
     */
    reservations?: Array<JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservation>;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest
     */
    subsidyRequiredAmountTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest
     */
    subsidyNoRequiredAmountTotal?: number;
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest {
    return JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'couponApplicable': !exists(json, 'couponApplicable') ? undefined : ((json['couponApplicable'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableFromJSON)),
        'reservations': !exists(json, 'reservations') ? undefined : ((json['reservations'] as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationFromJSON)),
        'subsidyRequiredAmountTotal': !exists(json, 'subsidyRequiredAmountTotal') ? undefined : json['subsidyRequiredAmountTotal'],
        'subsidyNoRequiredAmountTotal': !exists(json, 'subsidyNoRequiredAmountTotal') ? undefined : json['subsidyNoRequiredAmountTotal'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestToJSON(value?: JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'couponApplicable': value.couponApplicable === undefined ? undefined : ((value.couponApplicable as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestCouponApplicableToJSON)),
        'reservations': value.reservations === undefined ? undefined : ((value.reservations as Array<any>).map(JpCoBenefitoneBsdpBffPresentationRequestSubsidyPutRequestReservationToJSON)),
        'subsidyRequiredAmountTotal': value.subsidyRequiredAmountTotal,
        'subsidyNoRequiredAmountTotal': value.subsidyNoRequiredAmountTotal,
    };
}

